module.exports = __webpack_public_path__ + "media/file.79e69615.mp3";